import createReducer from 'utils/redux/createReducer'

const initialState = {
	userName: ''
  , userID: ''
}

export default createReducer(initialState, {
	STORE_LOGIN: (currentState, action) => ({
		userName: (action.data.userName)? action.data.userName : currentState.userName
	  , userID: (action.data.userID)? action.data.userID : currentState.userID
	})
  , CLEAR_LOGIN: (currentState, action) => initialState
})



// WEBPACK FOOTER //
// ./src/reducers/login.js